module.exports = __webpack_public_path__ + "img/home5.28ef859a.jpg";